'use strict'

var culture = require('./culture.js');

$(window).on('load', function () {
    loginInit();   
});

function loginInit() {
console.log('login init success');
	$('#language').find('.k-toggle-button').on('click', function () {
		if (!$(this).hasClass('active-btn')) {
			$(this).addClass('active-btn k-state-active').siblings('.active-btn').removeClass('active-btn k-state-active');
		}
	});

	$('.k-split-button .k-overflow-button').on('click', function () {
		$(this).addClass('current-lang').siblings('.current-lang').removeClass('current-lang');
	});

	checkFields();

    $('#loginForm input').on('change keyup input', checkFields);

	// for autofill in Google Chrome (input:-webkit-autofill)
	setTimeout(function () {
	    $('#password').trigger('change');

	    window.scrollTo((document.body.scrollWidth - document.documentElement.clientWidth * 4) / 2, 0);
	}, 1);
};

function checkFields() {
	if ($('#username').val().length === 0 || ($('#password').val().length === 0 && $('#password:-webkit-autofill').length === 0)) {
		$('#loginSubmit').prop('disabled', 'disable').addClass('k-state-disabled');
	} else {
		$('#loginSubmit').prop('disabled', '').removeClass('k-state-disabled');
	}
}

function changeLanguage(e) {
	if (e.id.length > 0) {
		culture.change(e.id);
	}
}

function openAdditionalLanguages() {

}

window.changeLanguageClick = changeLanguage;
window.openAdditionalLanguages = openAdditionalLanguages;
